import api from "api";
import { supportApiBase } from "api/hooks/useHCPs";
import { useMutation } from "react-query";
import { useId } from "utils/hooks";

const useCreatePublicProfile = () => {
  const id = useId();

  return useMutation(() =>
    api.call(`/therapists/${id}/public_profiles`, {
      method: "POST",
      root: supportApiBase,
    })
  );
};

export default useCreatePublicProfile;
